import styled from "styled-components";
import { BREAKPOINTS } from "../../components/grid";

export const PageLayoutStyle = styled.div``;

export const MainContentContainerStyle = styled.main`
  max-width: 1440px;
  min-height: 82vh;
  margin: 0 auto;

  @media only screen and (max-width: ${BREAKPOINTS.XXL}px) {
    padding: 0 48px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    padding: 0 16px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    padding: 0 8px;
  }
`;
